export default __webpack_public_path__ + "assets/sunbit-blue-logo.svg";